export const PaymentTypes = {
  FREE: 'free',
  PAID: 'paid',
  FUNDRAISER: 'fundraiser'
};
